import React, { Component } from 'react'
import { connectModal } from 'redux-modal'
import { Button, Modal } from 'react-bootstrap'
import styled from 'styled-components'
import closeImage from "../../../../images/black-x.svg"
import preApprovalIcon from "../../../../images/pre-approval.png"
import {SUPPRESS_PRE_APPROVAL_AD} from "manager/views/components/Referral/Common/constants"

const StyledModal = styled(Modal)`
  .modal-dialog {
    @media screen and (max-width: 520px){
      width: 100%;
      height: 100%;
      margin: 0px;
      overflow-y: scroll;
    }
  }
  .modal-content {
    @media screen and (max-width: 520px){
      width: 100%;
      height: 100%;
      overflow-y: scroll;
    }
  }
  .modal-header {
    padding: 0px;
    border: none;
    height: 41px;
  }
  .modal-body {
    padding: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    height: 563px;
    @media screen and (max-width: 520px){
      height: 100%;
    }
  }
}
`

const CloseIcon = styled.div`
  position: absolute;
  top: 18px;
  right: 18px;
  height: 23px;
  width: 23px;
  background-image: url(${closeImage});
`
const IllustrationContainer = styled.div`
  display: flex;
  justify-content: center
  flex: 0 0 30%;
`
const Icon = styled.div`
  height: 234px;
  width: 330px;
  background-image: url(${preApprovalIcon});
`
const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 191px;
  flex: 0 0 50%;
  padding-bottom: 5%;
  @media screen and (max-width: 520px){
    padding-bottom: 20%;
  }
`
const ContentBoldText = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 27px;
  text-align: center;
  color: #4A4A4A;
  padding: 0% 12%;
  @media screen and (max-width: 520px){
    padding: 0% 9%;
  }
`
const ContentText = styled.div`
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #4A4A4A;
  padding: 0% 7%;
  @media screen and (max-width: 520px){
    padding: 0% 10%;
  }
`
const ContinueButton = styled(Button)`
  width: 132px;
  height: 41px;
  font-weight: 900;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  letter-spacing: 0.567273px;
  color: #FFFFFF;
  background: #22A7FF;
  border-radius: 2px;
  text-transform: none;
`
class PreApprovalAd extends Component {

  handleHide = () => {
    const {handleHide} = this.props
    handleHide()
    localStorage.setItem(SUPPRESS_PRE_APPROVAL_AD, "true")
  }

  render() {
    return (
      <StyledModal show={this.props.show && !localStorage.getItem(SUPPRESS_PRE_APPROVAL_AD)}>
        <Modal.Header>
          <CloseIcon onClick={this.handleHide} />
        </Modal.Header>
        <Modal.Body>
          <IllustrationContainer>
            <Icon/>
          </IllustrationContainer>

          <ContentContainer>
            <ContentBoldText>NEW! Client pre-approval information now available</ContentBoldText>
            <ContentText>We will notify you when your client is pre-approved for a loan with one of our digital network
              lenders. </ContentText>
            <ContinueButton onClick={this.handleHide}>Continue ›</ContinueButton>
          </ContentContainer>
        </Modal.Body>
      </StyledModal>
    )
  }
}

const PreApprovalAdModal = connectModal({ name: 'PreApprovalAdModal', destroyOnHide: true })(PreApprovalAd)

export default PreApprovalAdModal
